import { apiCall, createQueryString } from "../imports"

const PREFIX = "management/faq/categories"

export default {

    get(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`);
    },

    update(faqId,data) {
        return apiCall('post', `${PREFIX}/${faqId}/update`, data);
    },

    create(data) {
        return apiCall('post', `${PREFIX}`, data);
    },

    delete(faqId) {
        return apiCall('delete', `${PREFIX}/${faqId}`);
    },
}